export default "__VITE_ASSET__Bw9j8pvS__"